import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangePassengerSurnameCommand extends BaseCommand {
  CommandName = "ChangePassengerSurname";
  Command: {
    Value: string;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Value: value };
  }
}
